module.exports = __webpack_public_path__ + "img/9788952210746.2daf4d0a.jpg";